<template>
    <div class="create-email-template-form">
        <div class="create-email-template-form-models">
            <div
                class="create-email-template-form-models-item"
                :class="{ selected: formData.template === 'empty' }"
                @click="formData.template = 'empty'"
            >
                <div class="create-email-template-form-models-item-model">
                    <EmptyIcon />
                </div>
                {{ $t("mail.empty") }}
            </div>
            <div
                class="create-email-template-form-models-item"
                :class="{ selected: formData.template === 'summer' }"
                @click="formData.template = 'summer'"
            >
                <div class="create-email-template-form-models-item-model">
                    <EmptyIcon />
                </div>
                {{ $t("mail.summerDiscounts") }}
            </div>
            <div
                class="create-email-template-form-models-item"
                :class="{ selected: formData.template === 'opportunity' }"
                @click="formData.template = 'opportunity'"
            >
                <div class="create-email-template-form-models-item-model">
                    <EmptyIcon />
                </div>
                {{ $t("mail.opportunities") }}
            </div>
        </div>
        <a-form-model ref="form" :model="formData" :rules="rules" layout="vertical">
            <a-form-model-item :label="$t('mail.templateName')" prop="name">
                <a-input v-model="formData.name" />
            </a-form-model-item>
            <a-form-model-item :label="$t('message.subject')" prop="subject">
                <a-input v-model="formData.subject" />
            </a-form-model-item>
            <a-form-model-item :label="$t('mail.category')" prop="category">
                <a-select v-model="formData.category">
                    <a-select-option value="marketing">{{ $t("mail.marketing") }}</a-select-option>
                    <a-select-option value="operational">{{ $t("mail.operational") }}</a-select-option>
                    <a-select-option value="private">{{ $t("mail.custom") }}</a-select-option>
                </a-select>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
import Vue from "vue";
import EmptyIcon from "../icons/Empty.vue";

export default Vue.extend({
    name: "CreateEmailTemplateForm",
    components: { EmptyIcon },
    data() {
        return {
            formData: {
                template: "empty",
                name: "",
                subject: "",
                category: undefined,
            },
            rules: {
                name: [{ required: true, message: this.$t("mail.pleaseEnterTemplateName") }],
                subject: [{ required: true, message: this.$t("mail.pleaseEnterTemplateSubject") }],
                category: [{ required: true, message: this.$t("mail.pleaseSelectTemplateCategories") }],
            },
        };
    },
    methods: {
        getFormData() {
            return this.formData;
        },
    },
});
</script>

<style scoped lang="scss">
.create-email-template-form {
    &-models {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 5px;
        margin-bottom: 10px;
        &-item {
            width: 100%;
            height: 100px;
            background-color: #f0f0f0;
            border-radius: 5px;
            border: 1px solid #e9e9e9;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2px;
            cursor: pointer;
            &-model {
                width: 50px;
                height: 50px;
                svg {
                    width: 100%;
                    height: 100%;
                }
            }
            &.selected {
                border: 1px solid #fe6244;
            }
        }
    }
}
</style>
